import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import SEOMeta from "@/components/SEOMeta";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname,
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <SEOMeta
        title="404 - Page Not Found | Docpose.Cloud"
        description="The page you're looking for doesn't exist. Return to our homepage to access our file conversion tools."
        noIndex={true}
      />
      <div className="text-center">
        <h1 className="text-3xl font-bold mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-4">Oops! Page not found</p>
        <a href="/" className="text-blue-500 hover:text-blue-700 underline">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
